import * as React from 'react'
import { useState } from 'react'
import { Stack, Box, Typography, } from '@mui/material'
import * as sx from '../../common/stylesInline/report_daily_branch'
import Button from '@mui/material/Button'
import Lineinput from '../../common/lineinput'
import Modal from '../../common/modal'
import { Item } from '../../common/snippets'
import { navigation1, navigation3 } from '../../common/helper'
import OTPTimer from '../../header/OTPTimer'
import { useAtom } from 'jotai'
import { modalAtom } from '../../common/jotaiState/globalStateAtoms'
const ReceipientOTPModel = (props) => {
    const { saveApi, OTP, sendOTPRequest,userOTP, setUserOtp,recipientMobNo ,showHeader=false,changeHeadingText=false} = { ...props }
    const {to='Receipient'} = { ...props }
    const [otperror, setOtpError] = useState(false)
    const [resendOTP, setResendOTP] = useState(false)
    const [,setModal] = useAtom(modalAtom)
    const modalStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }

    const otpHandleChange = (e) => {
        setOtpError(false)
        setUserOtp(e.target.value)
    }
    const otpValidation = () => {
        if (OTP.toString() === userOTP.toString()) {
            setOtpError(false)
            setUserOtp('')
            saveApi(true)
        } else {
            setOtpError(true)
        }
    }
    return (
        <>
            <Modal showHeader={showHeader} headTxt={`Submit OTP`} modalStyle={modalStyle} modalClass={'booking-popup'} width={'25%'} closeId={"closeButton"} updateModal={setModal} sx={{ marginTop: '20px' }}>
                <Stack>
                    <Item >
                    <Typography style={{textAlign:'center',paddingTop:'10px',fontSize:'14px',fontWeight:'700'}}>{changeHeadingText? 'OTP Sent To Approval Authority': `OTP is sent to ${to} mobile no ${recipientMobNo}`}</Typography>
                    </Item>
                    <Item className={'input--wrapper'} style={{ margin: "5px 10px" }}>
                        <Lineinput
                            id={`Enter_OTP`}
                            label={`Enter OTP`}
                            width="11%"
                            type="text"
                            name="Enter_OTP"
                            value={userOTP || ''}
                            autoFocus={true}
                            onChange={(e) => otpHandleChange(e)}
                            onKeyDown={(e)=>navigation1(e,"OTPSubmitBtn","OTPSubmitBtn")}
                            isError={otperror}
                        />
                    </Item>
                    {otperror ? (
                        <Box style={{ marginLeft: "30px", display: "flex", gap: "7px", fontSize: '14px', marginBottom: "10px" }}>
                            <span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none">
                                    <path d="M8.25 8.4165H6.75V3.9165H8.25M8.25 11.4165H6.75V9.9165H8.25M7.5 0.166504C6.51509 0.166504 5.53982 0.360497 4.62987 0.737407C3.71993 1.11432 2.89314 1.66676 2.1967 2.3632C0.790176 3.76973 0 5.67738 0 7.6665C0 9.65563 0.790176 11.5633 2.1967 12.9698C2.89314 13.6662 3.71993 14.2187 4.62987 14.5956C5.53982 14.9725 6.51509 15.1665 7.5 15.1665C9.48912 15.1665 11.3968 14.3763 12.8033 12.9698C14.2098 11.5633 15 9.65563 15 7.6665C15 6.68159 14.806 5.70632 14.4291 4.79638C14.0522 3.88644 13.4997 3.05964 12.8033 2.3632C12.1069 1.66676 11.2801 1.11432 10.3701 0.737407C9.46018 0.360497 8.48491 0.166504 7.5 0.166504Z" fill="#F05924" />
                                </svg>
                            </span>
                            <span style={{ color: 'red', fontWeight: "400" }}>Wrong OTP Entered</span>{' '}
                        </Box>
                    ) : (
                        ''
                    )}
                </Stack>
                <Stack>
                    <Item sx={sx.itemsx} style={{ display: "flex", justifyContent: "center", margin: "5px 0px",width:'100%' }} className="disabled-wrapper" onKeyDown={(e) => navigation3(e, "Enter_OTP", "Enter_OTP", () => { })}>
                        <Button variant="contained" id="OTPSubmitBtn" style={{ ...sx.fullHeight, ...sx.novp,width:'100%', margin: "0px 17px" }} className="btn btn-primary" onClick={otpValidation}>
                            SUBMIT
                        </Button>
                    </Item>
                    <Item>
                    {/* <Typography style={{textAlign:'center',paddingTop:'10px',fontSize:'14px',fontWeight:'700'}}>You can resend the OTP in 03:00</Typography> */}
                     <OTPTimer duration={1*60} resendOTP={resendOTP}  setResendOTP={setResendOTP}/>
                     {/* {error && <p style={{ color: 'red' }}>{error}</p>} */}
                    </Item>
                </Stack>
                <Box style={{ color: "#0009", display: "flex", justifyContent: "center",marginBottom:'20px' }}>
                        <span onClick={()=>{sendOTPRequest();setResendOTP(true);setUserOtp('')}} style={{cursor:"pointer",borderBottom:'1px solid #0009'}}>
                            Resend OTP
                        </span>
                    </Box>
            </Modal>
        </>
    )
}
export default ReceipientOTPModel
